import { render, staticRenderFns } from "./trainingFolderView.vue?vue&type=template&id=4e879606"
import script from "./trainingFolderView.vue?vue&type=script&lang=js"
export * from "./trainingFolderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports